export default __webpack_public_path__ + "images/345afabf880b6e65f82cb8063481a165-aila_logo.png";